import classNames from 'classnames';
import { ADMIN_BILLING, BASE } from '../../../../routes';
import { ThumbCard } from '../../../components/Cards';
import Ribbon from '../../../components/Cards/Ribbon';
import Link from '../../../components/Link';
import { hasBasicHr, isManager } from '../../../services/User';
import styles from './style.m.less';

export default function AdminLink({
    name,
    url,
    tooltip,
    enabled,
    status,
    icon,
    className,
    target,
    currentUser = undefined,
}) {
    const linkClasses = classNames(styles.card, className, {
        [styles.hasWarning]: status === 'WARNING',
        [styles.hasError]: status === 'ERROR',
    });
    let iconSrc = require(`./svg/default.svg`);
    try {
        iconSrc = require(`./svg/${icon}.svg`);
    } catch {
        // ignore error as we fall back to default svg
    }
    const isBillingButton = url === BASE + ADMIN_BILLING;
    const showBuyRibbon = isBillingButton && isUserToPurchase(currentUser);
    const card = (
        <ThumbCard isEnabled={enabled} className={linkClasses} isCompact={true}>
            {showBuyRibbon && <Ribbon text="Buy Here" color="BLUE" />}
            <img className={styles.image} src={iconSrc} alt="" />
            <div>{name}</div>
        </ThumbCard>
    );

    return enabled ? (
        <Link href={url} className={styles.gridItem} hasTextStyle={false} data-tooltip={tooltip} target={target}>
            {card}
        </Link>
    ) : (
        <div className={styles.gridItem} data-tooltip={tooltip}>
            {card}
        </div>
    );
}

function isUserToPurchase(currentUser) {
    if (currentUser) {
        const {
            company: {
                payment: { plan, userCount, freeLimit },
            },
        } = currentUser;

        return (hasBasicHr(currentUser) || isCEO(currentUser)) && plan === 0 && userCount > freeLimit;
    }
    return false;
}

function isCEO(user) {
    return !user.isGuest && isManager(user) && !user.managerId;
}
